import api from '@/api';
import { CLOSE_TYPE } from '@/constants/settings';
import { commonHelpers } from '@/helpers/common';

export default {
    namespaced: true,
    state: {
        isAppConfigLoaded: false,
        appConfig: {},
    },
    getters: {
        getFaqCloseButtonType(state) {
            const configType = state.appConfig?.game_config?.faq_close_button_type;
            if (configType) return configType;
            if (commonHelpers.isWebView()) return CLOSE_TYPE.WEBVIEW;
            if (commonHelpers.isIframe()) return CLOSE_TYPE.BUTTON;
            return CLOSE_TYPE.NONE;
        },
        getMaxFileSize(state) {
            return state.appConfig?.ticket_config?.attachments.max_file_size_in_mb;
        },
        getMaxFilesCount(state) {
            return state.appConfig?.ticket_config?.attachments.max_files_count;
        },
        getDescriptionMinLength(state) {
            return state.appConfig?.ticket_config?.description_min_length;
        },
        getSendTimeout(state) {
            return (state.appConfig?.ticket_config?.throttle?.store_limit_in_minute_by_user || 0) * 1000 * 60;
        },
        getAppConfigEmptyStatus(state) {
            return !state.isAppConfigLoaded || !(Object.keys(state.appConfig).length);
        }
    },
    mutations: {
        setAppConfig(state, appConfig) {
            state.appConfig = {
                ...state.appConfig,
                ...appConfig
            }
        },
        setAppConfigLoadedState(state) {
            state.isAppConfigLoaded = true
        },
    },
    actions: {
        async fetchAppConfig({ commit }) {
            try {
                const response = await api.getAppConfig(this.state.queryParams);
                const appConfig = response?.data?.data?.attributes
                commit('setAppConfig', appConfig)
            } catch (error) {
                console.error(error)
            } finally {
                commit('setAppConfigLoadedState')
            }
        }
    },
};